import {computed, reactive, ref, onMounted, onBeforeUnmount} from 'vue'
import {useStore} from 'vuex'

import FilterControls from './FilterComponentControls.vue'

export default {
    name: "FilterComponent",
    components:{
        FilterControls
    },
    props:{
        mobileDrawerContext:{
            default: false
        }
    },
    setup(){
        const store = useStore()
        const facets = computed(()=>store.getters['productSearch/mainFacetsExcluded'])
        const mainFilterFacets = computed(()=>store.getters['productSearch/mainFilterFacets'])
        const selectedFacets = computed(()=>store.getters['productSearch/selectedFacetsOrdered'])
        const filterCount = computed(()=>store.state.productSearch.search_result_max_count)
        const searchString = computed(()=> store.state.productSearch.search_string)
        const renderEpoch = ref(0)

        const expandedFilters = reactive({})
        const expandFilter = function(groupName){
            const currentState = !(expandedFilters[groupName])
            expandedFilters[groupName] = currentState
        }

        const filterBarExpanded = computed(()=>store.state.productSearch.filterColumnVisible)
        const expandFilterBar = function(){
            store.commit('productSearch/toggleFilterColumnVisilibity', !(filterBarExpanded.value))
        }

        const selectFacet = function(group,facet){
            if (searchString.value.length <= 2)
                store.commit('productSearch/set_search_string','')
            store.dispatch("productSearch/filterProducts",{
                group:group.name,
                facet:facet.name
            })
        }

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }

        const closeMobileFilter = ()=> store.commit('main/set_mobile_drawer_component','')

        const syncFromUrl = () => {
            store.dispatch('productSearch/performInitialSearch', { searchString: location.search })
            renderEpoch.value++
        }

        onMounted(()=>{
            syncFromUrl()
            window.addEventListener('pageshow', syncFromUrl)
        })

        onBeforeUnmount(() => {
            window.removeEventListener('pageshow', syncFromUrl)
        })

        return {
            expandFilter,
            expandedFilters,
            expandFilterBar,
            facets,
            filterBarExpanded,
            mainFilterFacets,
            selectFacet,
            selectedFacets,
            getLabel,
            closeMobileFilter,
            filterCount,
            renderEpoch
        }
    }
}
